import React from 'react';
import { Grid } from 'antd';

// Acota y centra el contenido de una pestaña en desktop (≥lg). En mobile es
// passthrough (100%). `width` elige el ancho máximo por tipo de contenido.
const MAX = { narrow: 760, wide: 1200, checklist: 1180 };

function MantencionTabShell({ width = 'narrow', children }) {
  const screens = Grid.useBreakpoint();
  if (!screens.lg) return children;
  return (
    <div style={{ maxWidth: MAX[width] ?? MAX.narrow, margin: '0 auto', width: '100%' }}>
      {children}
    </div>
  );
}

export default MantencionTabShell;
